
<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="home">
    <!-- Section de bannieres -->
    <b-row class="firstSection">
      <b-col class="section">
        <b-row class="h-100 mx-auto align-items-center justify-content-center">
          <b-col>
            <h1 class="align-middle h-100 p-2 text-left text-section">
              Votre Prochain logement se trouve ici
              <vs-button v-scrollanimation>En savoir plus </vs-button>
            </h1>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="sectionAnnonce d-lg-flex d-none"> </b-col>
    </b-row>

    <!-- section de recherche -->
    <div class="formSearch">
      <!-- <vx-card>
        <b-row>
          <b-col sm="6" lg="7" class="mb-4 mb-md-0">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-map-pin"
              label-placeholder="Entrer le lieu"
              v-model="place"
              size="lg"
          /></b-col>
          <b-col sm="6" lg="3" align-self="end" class="mb-4 mb-md-0">
            <b-form-select
              v-model="selected"
              :options="options"
              size="lg"
            ></b-form-select
          ></b-col>
          <b-col sm="6" lg="2" align-self="center">
            <b-button variant="outline-primary" block @click="search" size="lg"
              >Rechercher</b-button
            >
          </b-col>
        </b-row>
      </vx-card> -->
      <vx-card>
        <b-row>
          <b-col sm="6" lg="7" class="mb-4 mb-md-0">
          <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-map-pin"
              label-placeholder="Entrer le lieu"
              v-model="place"
              size="lg"
          />
           </b-col>
            <b-row>
          <b-card class="placeSuggestionSection d-sm-flex d-none" v-if="suggestionsPlaces">
            <b-row v-for="place in suggestionsPlaces " :key="place.id" class="placeSuggestion" @click="selectPlace(place)">
              <b-col cols="1">
                 <p class="h2"> <b-icon icon="geo-alt-fill"></b-icon></p>
              </b-col>
              <b-col> <p >{{place.place_name }}</p> </b-col>
            </b-row>
          </b-card>
        </b-row>
          <b-col sm="6" lg="3" align-self="end" class="mb-4 mb-md-0">
            <b-form-select
              v-model="selected"
              :options="options"
              size="lg"
            ></b-form-select
          ></b-col>
          <b-col sm="6" lg="2" align-self="center">
            <b-button variant="outline-primary" block @click="search" size="lg"
              >Rechercher</b-button
            >
          </b-col>
        </b-row>
      </vx-card>
        <b-row>
          <b-card class="placeSuggestionSection d-lg-flex d-none m" v-if="suggestionsPlaces">
            <b-row v-for="place in suggestionsPlaces " :key="place.id" class="placeSuggestion" @click="selectPlace(place)">
              <b-col cols="1">
                 <p class="h2"> <b-icon icon="geo-alt-fill"></b-icon></p>
              </b-col>
              <b-col> <p >{{place.place_name }}</p> </b-col>
            </b-row>
          </b-card>
        </b-row>
    </div>
    <br />

    <!-- section de carousel/ slide -->
    <div class="section-carousel px-5">
      <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        fade
        indicators
        img-width="1024"
        img-height="100"
      >
        <b-carousel-slide
          v-for="item in imgList"
          :key="item.id"
          :img-src="carouselImage(item.src)"
        >
        </b-carousel-slide>
      </b-carousel>
    </div>

    <!-- section for you -->
    <div class="foryoubackground pt-5">
      <div class="forYouSection" v-scrollanimation>
        <div class="vx-row forYou" v-appear:left="{ delay: 100 * 1 }">
          <h1 class="text-left">Pour vous</h1>
          <div
            class="mycard__collection clear-fix"
            v-if="this.$store.state.windowWidth > 760"
          >
            <div
              class="cards cards--two"
              v-for="(location, index) in locations"
              :key="index"
              @click="goToPage(location.town)"
            >
              <img :src="location.pic" class="img-fluid" alt="Cards Image" />
              <span class="cards--two__rect"></span>
              <span class="cards--two__tri">
                <p style="padding-left: 70px">{{ location.country }}</p></span
              >
              <p>{{ location.town }}</p>
            </div>
          </div>
          <b-row v-else>
            <b-col
              sm="12"
              md="12"
              v-for="(location, index) in locations"
              :key="index"
              @click="goToPage(location.town)"
              class="p-5"
            >
              <b-img :src="location.pic" fluid />
              <div class="bottom-left text-capitalize h2 cursor text-white">
                <p></p>
                {{ location.town }}
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- section categories -->
    <div class="categories-sections p-5">
      <br />
      <div class="vx-row mt-5">
        <div class="vx-col w-full lg mb-base">
          <h1 class="text-center text-white">Categories</h1>
        </div>
      </div>
      <div class="vx-row">
        <!-- CARD 1: CONGRATS -->
        <div class="vx-col w-full lg:w-1/2 mb-base">
          <vx-card class="overflow-hidden bungalow categoryCard">
            <h2 class="category text-bold">Cabanes</h2>
          </vx-card>
        </div>

        <!-- CARD 2: SUBSCRIBERS GAINED -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <vx-card class="overflow-hidden unique categoryCard">
            <h2 class="category text-bold">Logements Uniques</h2>
          </vx-card>
        </div>

        <!-- CARD 3: ORDER RECIEVED -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <vx-card class="overflow-hidden experience categoryCard">
            <h2 class="category text-bold">Expériences exceptionnelles</h2>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <!-- CARD 4: SESSION -->
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card class="overlay-card overflow-hidden appartment categoryCard">
            <h2 class="category text-bold">Appartements</h2>
          </vx-card>
        </div>
        <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card class="overlay-card overflow-hidden entireHome categoryCard">
            <h2 class="category text-bold">Maisons entiers</h2>
          </vx-card>
        </div>
        <!-- CARD 5: SUPPORT TRACKER -->
      </div>
    </div>
  </div>
</template>

<script>
import CarouselAutoplay from '@/components/extra-components/carousel/CarouselAutoplay'

export default {
  data () {
    return {
      selected: null,
      slide: 0,
      sliding: null,
      suggestionsPlaces: null,
      imgList: [
        {
          id: 0,
          src: 'carousel1.jpg'
        },
        {
          id: 1,
          src: 'carousel2.jpg'
        },
        {
          id: 2,
          src: 'carousel4.jpg'
        }
      ],
      options: [
        { value: null, text: 'Choisis une option' },
        {
          value: 'rental',
          text: 'Louer un immobilier'
        },
        {
          value: 'sale',
          text: 'Acheter un immobilier'
        }
      ],
      place: '',
      placeSearching:null,
      locations: [
        {
          town: 'Accra',
          country: 'Ghana',
          pic: require('@/assets/images/pages/home/accra.jpg'),
          logememts: ''
        },
        {
          town: 'Ouidah',
          country: 'Benin',
          pic: require('@/assets/images/pages/home/ouidah.jpg'),
          logememts: ''
        },
        {
          town: 'Lomé',
          country: 'Togo',
          pic: require('@/assets/images/pages/home/lome2.jpeg'),
          logememts: ''
        },
        {
          town: 'Cotonou',
          country: 'Benin',
          pic: require('@/assets/images/pages/home/etoile.jpg'),
          logememts: ''
        },
        {
          town: 'Dakar',
          country: 'Sénégal',
          pic: require('@/assets/images/pages/home/dakar.jpg'),
          logememts: ''
        }
      ]
    }
  },
  computed: {
    fetch_token_from_url () {
      return this.$route.params.token
    }
  },
  watch: {
    place (val) {
      if (val !== '' && this.placeSearching === null) {
        this.loadPlaceSuggestions(val)
      }
      
      
    }
  },
  methods: {
    selectPlace (placeSelected) {
      this.place =  placeSelected.place_name
      this.suggestionsPlaces = null
      this.placeSearching = placeSelected
    },
    onSlideStart () {
      this.sliding = true
    },
    onSlideEnd () {
      this.sliding = false
    },
    carouselImage (url) {
      if (url !== '') {
        // You can check any matching expression.
        try {
          url = require(`@/assets/images/pages/home/carousel/${url}`)
        } catch (e) {
          url = require('@/assets/images/pages/home/carousel/carousel1.jpg') // I used a default image.
        }
      } else url = require('@/assets/images/pages/home/carousel/carousel1.jpg') // Default image.
      return url
    },
    search () {
      if (this.selected === 'rental') {
        this.$router.push({
          name: 'rental',
          query: { place: this.place }
        })
      } else if (this.selected === 'sale') {
        this.$router.push({
          name: 'sell',
          query: { place: this.place }
        })
      }
    },
    goToPage (adress) {
      this.$router.push({
        name: 'rental',
        query: { place: adress }
      })
    },

    redirect_after_fetching () {
      if (this.fetch_token_from_url !== undefined) {
        this.$store.dispatch('auth/update_Token_and_userInfo', {
          access_token: this.fetch_token_from_url
        })
        window.location = '/'
      }
    },
    async loadPlaceSuggestions () {
      await this.$http.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.place}.json?access_token=pk.eyJ1Ijoib3JwaGVyaWMiLCJhIjoiY2t1bzlkNDcxMGNlbjJvbWRnbWIyOHN1YiJ9.qXEx5yXYTJ8w6nDz6QkGEw&cachebuster=1634055937300&autocomplete=true`).then((result => {
        this.suggestionsPlaces = result.data.features
      }))
    }
  },
  components: {
    CarouselAutoplay
  },
  created () {
    this.redirect_after_fetching()
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#home {
  .foryoubackground {
    background-color: #ececec;
  }
  .foryouTitle {
    margin-top: 25px;
  }
  .section-carousel {
    @media (min-width: 1200px) {
      height: 600px;
    }
    .img-fluid {
      @media (min-width: 1200px) {
        height: 600px;
      }
    }
  }
  .appartment {
    min-height: 25rem;
    background-image: url("../../../../assets/images/pages/home/appartment.jpg");
    background-size: cover;
    background-position: center;
  }
  .experience {
    min-height: 20rem;
    background-image: url("../../../../assets/images/pages/home/experience.jpg");
    background-size: cover;
    background-position: center;
  }
  .unique {
    min-height: 20rem;
    background-image: url("../../../../assets/images/pages/home/unique.jpg");
    background-position: center;
    background-size: cover;
  }
  .category {
    margin-top: 175px;
    color: white;
  }
  .bungalow {
    min-height: 20rem;
    background-image: url("../../../../assets/images/pages/home/bungalow.jpg");
    background-position: left;
    background-size: cover;
  }
  .entireHome {
    min-height: 25rem;
    background-image: url("../../../../assets/images//pages/home/photo.jpg");
    background-size: cover;
    background-position: center;
  }
  .categories-sections {
    background-color: #383838;
  }

  .forYou {
    padding: 0px;
  }
  .categoryCard:hover {
    cursor: pointer;
    opacity: 0.7;
    transition: all 1s ease;
    -webkit-transform: scale(1.07);
    transform: scale(1.07);
  }
  .formSearch {
    padding: 30px;
    @media (min-width: 1200px) {
      margin: 0px 200px 0px 200px;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }

  .section {
    min-height: 70vh;
    background-color: #f2f2f2;
    background-size: cover;
    @media (max-width: 992px) {
      background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
        url(../../../../assets/images/pages/home/interior.jpg);
      background-position: center;
      .text-section {
        margin: 0;
        padding: 2rem;
        color: white;
        text-align: center;
      }
    }
  }
  .firstSection {
    margin-top: -100px;
  }
  .text-section {
    margin: 0;
    padding: 2rem;
    text-align: center;
  }

  .sectionAnnonce {
    background-position: left;
    background-size: cover;
    background-image: url(../../../../assets/images/pages/home/interior-yellow.jpg);
  }

  .forYouSection {
    margin: 50px;
    @media screen and (max-width: 767px) {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  .before-enter {
    opacity: 0;
    transform: translateX(100px);
    transition: all 1.5s cubic-bezier(0.17, 0.67, 0.55, 0.09);
  }

  .enter {
    opacity: 1;
    transform: translateX(0px);
  }

  body {
    width: 100vw;
    background-color: #1d1d1d;
    margin: 0;
    font-family: helvetica;
  }

  .wrapper {
    width: 100vw;
    margin: 0 auto;
    height: 400px;
    background-color: #161616;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all 0.3s ease;
  }

  @media screen and (max-width: 767px) {
    .wrapper {
      height: 700px;
    }
  }

  .content {
    max-width: 1024px;
    width: 100%;
    padding: 0 4%;
    padding-top: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: 767px) {
    .content {
      padding-top: 100px;
      flex-direction: column;
    }
  }

//   .card {
//     width: 100%;
//     max-width: 500px;
//     min-width: 300px;
//     height: 350px;
//     background-color: #ffffff;
//     margin: 10px;
//     border-radius: 10px;
//     box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
//     border: 2px solid rgba(7, 7, 7, 0.12);
//     font-size: 16px;
//     transition: all 0.3s ease;
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     cursor: pointer;
//     transition: all 0.3s ease;
//   }

// .card .title {
//     width: 100%;
//     margin: 0;
//     text-align: center;
//     margin-top: 20px;
//     color: black;
//     font-weight: 600;
//     text-transform: uppercase;
//     letter-spacing: 4px;
//   }

//   .card .text {
//     width: 80%;
//     margin: 0 auto;
//     font-size: 13px;
//     text-align: center;
//     margin-top: 20px;
//     color: black;
//     font-weight: 200;
//     letter-spacing: 2px;
//     opacity: 0;
//     max-height: 0;
//     transition: all 0.3s ease;
//   }

//   .card:hover {
//     height: 300px;
//   }

//   .card:hover .info {
//     height: 90%;
//   }

//   .card:hover .text {
//     transition: all 0.3s ease;
//     opacity: 1;
//     max-height: 40px;
//   }

//   .card:hover .icon {
//     background-position: -120px;
//     transition: all 0.3s ease;
//   }

//   .card:hover .icon i {
//     background: linear-gradient(90deg, #807575, #f0b104);
//     -webkit-background-clip: text;
//     opacity: 1;
//     transition: all 0.3s ease;
//   }

  .icon {
    margin: 0 auto;
    width: 100%;
    height: 80px;
    max-width: 80px;
    background: linear-gradient(
      90deg,
      #ffffff 0%,
      #f0b104 40%,
      rgba(0, 0, 0, 0.28) 60%
    );
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    transition: all 0.8s ease;
    background-position: 0px;
    background-size: 200px;
  }

  // *,
  // *:before,
  // *:after {
  //   margin: 0;
  //   padding: 0;
  //   box-sizing: border-box;
  // }

  .clear-fix:after {
    display: block;
    clear: both;
    content: "";
  }

  .img-responsive {
    max-width: 100%;
    height: auto;
  }

  $color-box-1: #0f9bc0;
  $color-box-2: rgba(34, 65, 154, 0.8);
  $color-box-3: #000000;
  $color-box-4: #e660e3;
  $color-box-5: #f0b104;
  $color-box-6: #9b1308;
  $color-box-7: #f0b104;

  .mycard__collection {
    position: relative;
    display: block;
    @media (max-width: 600px) {
      padding: 01px;
      width: 100%;
    }
    font-family: "Do Hyeon", sans-serif;
    overflow: hidden;

    .cards {
      width: 300px;
      height: 400px;
      display: block;
      background-size: cover;
      float: left;
      border-radius: 15px;
      position: relative;
      overflow: hidden;
      background-position: center;
      margin: 10px;
      @media (max-width: 600px) {
        margin: 02px;
      }
    }
    .cards:hover {
      cursor: pointer;
    }
    .cards--one {
      backface-visiblility: hidden;
      &:hover {
        &:after {
          bottom: -20px;
        }

        &:before {
          bottom: -10px;
        }

        .cards--one__rect {
          left: 45%;

          &--back {
            left: 50%;
          }
        }
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        height: 70px;
        transform: rotate(-3deg);
        background: $color-box-4;
        position: absolute;
        bottom: -80px;
        left: 0;
        right: -10px;
        z-index: 9;
        transition: all 0.2s ease-in;
        transition-delay: 0.3s;
      }

      &:before {
        content: "";
        display: block;
        position: absolute;
        height: 80px;
        transform: rotate(-3deg);
        bottom: -90px;
        left: 0;
        background: #fff;
        right: -10px;
        z-index: 5;
        transition: all 0.2s ease-in;
        transition-delay: 0.1s;
      }

      &__rect {
        color: #fff;
        text-transform: uppercase;
        font-size: 18px;
        background: $color-box-1;
        width: 126px;
        height: 55px;
        transform: skewY(5deg);
        position: absolute;
        display: block;
        top: 60%;
        left: -45%;
        z-index: 1;
        line-height: 3.3rem;
        text-align: center;
        transition: all 0.2s ease-in;

        &--back {
          display: block;
          background: $color-box-2;
          width: 126px;
          height: 55px;
          transform: skewY(7deg);
          position: absolute;
          top: 65%;
          left: -50%;
          transition: all 0.2s ease-in;
          transition-delay: 0.3s;
        }

        p {
          transform: skewY(-7deg);
          position: relative;
        }
      }
    }

    .cards--two {
      position: relative;
      backface-visibility: hidden;

      p {
        position: absolute;
        top: 83%;
        left: -100%;
        text-transform: capitalize;
        color: #fff;
        font-size: 20px;
        z-index: 8;
        transition: all 0.6s ease;
      }

      &:hover {
        p {
          left: 8%;
        }

        img {
          transform: translateY(-15px);
        }

        .cards--two__rect {
          top: 75%;

          &:before {
            transform: translateY(15px);
          }
        }

        li {
          transform: translateY(0);
        }

        .cards--two__tri {
          right: -40%;

          &:before {
            right: -312px;
          }
        }
      }

      img {
        transition: all 0.2s ease;
      }

      &__tri {
        border-top: 220px solid transparent;
        border-bottom: 190px solid transparent;
        border-right: 288px solid #fff;
        opacity: 0.9;
        position: absolute;
        display: block;
        top: 0;
        right: -100%;
        transition: all 0.3s ease-in-out;

        &:before {
          border-top: 220px solid transparent;
          border-bottom: 190px solid transparent;
          border-right: 288px solid $color-box-3;
          position: absolute;
          content: "";
          display: block;
          top: -220px;
          right: -612px;
          transition: all 0.3s ease-in-out;
          transition-delay: 0.2s;
        }
      }

      &__rect {
        width: 750px;
        height: 200px;
        background: #fff;
        display: block;
        position: absolute;
        top: 175%;
        left: -78%;
        transform: rotate(30deg);
        z-index: 5;
        opacity: 0.9;
        transition: all 0.3s ease-in-out;

        &:before {
          content: "";
          display: block;
          width: 100%;
          position: relative;
          height: 100%;
          background: $color-box-5;
          transform: translateY(200px);
          z-index: 2;
          transition: all 0.3s ease-in-out;
          transition-delay: 0.1s;
        }
      }

      ul {
        list-style: none;
        position: absolute;
        bottom: 0;
        left: 10px;
        z-index: 9;

        li {
          display: inline-block;
          font-size: 16px;
          margin: 7px;
          color: #fff;
          transition: all 0.2s ease-in-out;
          transform: translateY(100px);

          &:nth-child(2) {
            transition-delay: 0.2s;
          }

          &:nth-child(3) {
            transition-delay: 0.3s;
          }

          &:nth-child(4) {
            transition-delay: 0.4s;
          }
        }
      }
    }

    .cards--three {
      position: relative;
      z-index: 10;

      &:hover {
        .cards--three__rect-1 {
          left: 10%;

          .shadow-1 {
            left: -20%;
          }
        }

        .cards--three__rect-2 {
          left: 60%;

          &:before {
            left: -100%;
          }

          &:after {
            left: 80%;
          }

          .shadow-2 {
            left: -10%;
          }
        }

        .cards--three__circle {
          transform: scale(1);

          &:before {
            transform: scale(0.9);
          }
        }

        .cards--three__list {
          li {
            transform: translateX(0);
          }
        }
      }

      &__rect-1 {
        background: #fff;
        width: 200px;
        height: 110px;
        transform: skewX(-20deg);
        display: block;
        position: absolute;
        top: 73%;
        opacity: 0.9;
        left: -100%;
        z-index: 8;
        transition: all 0.5s ease-in;

        p {
          font-size: 20px;
          color: #fff;
          transform: skewX(20deg);
          line-height: 6rem;
        }

        .shadow-1 {
          background: $color-box-6;
          width: 230px;
          height: 100px;
          display: block;
          position: absolute;
          left: -200%;
          z-index: -1;
          transition: all 0.3s ease-in;
        }
      }

      &__rect-2 {
        width: 100px;
        height: 70px;
        background: #fff;
        position: absolute;
        top: 65%;
        left: 1000%;
        opacity: 0.9;
        transform: skewX(-20deg);
        z-index: 8;
        transition: all 0.5s ease-in;

        &::before {
          content: "";
          display: block;
          width: 50px;
          height: 40px;
          background: $color-box-3;
          opacity: 1;
          position: absolute;
          left: 500%;
          top: 10%;
          transition: all 0.3s ease-in;
        }

        &::after {
          content: "";
          display: block;
          width: 50px;
          height: 40px;
          background: $color-box-6;
          opacity: 1;
          position: absolute;
          left: 500%;
          top: 114%;
          transition: all 0.5s ease-in;
          transition-delay: 0.2s;
        }

        .shadow-2 {
          background: $color-box-3;
          width: 100%;
          height: 100%;
          display: block;
          position: absolute;
          top: -10%;
          left: 500%;
          transition: all 0.5s ease-in;
          transition-delay: 0.2s;
        }
      }

      &__circle {
        width: 220px;
        height: 220px;
        border-radius: 50%;
        background: #fff;
        position: absolute;
        top: -15%;
        left: 50%;
        opacity: 0.9;
        transform: scale(0);
        transition: all 0.3s ease;

        &:before {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          background: $color-box-6;
          border-radius: 50%;
          transform: scale(0);
          transition: all 0.3s ease;
          transition-delay: 0.2s;
        }
      }

      &__list {
        list-style: none;
        position: absolute;
        top: -9px;
        right: 7px;
        padding-top: 60px;
        transition: all 0.4s ease;

        li {
          display: inline-block;
          margin: 4px;
          color: #fff;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background: rgba(87, 204, 253, 0.9);
          text-align: center;
          line-height: 1.7rem;
          font-size: 12px;
          transition: all 0.3s ease;
          transform: translateX(500%);

          &:nth-child(1) {
            transition-delay: 0.2s;
          }

          &:nth-child(2) {
            transition-delay: 0.3s;
          }

          &:nth-child(3) {
            transition-delay: 0.4s;
          }
        }
      }
    }
  }
  .bottom-left {
    color: white;
    position: absolute;
    top: 85%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 100%;
    height: 30%;
    padding: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    text-align: center;
    backdrop-filter: blur(2px);
  }

.placeSuggestionSection{
   border-radius: 20px;
    text-align: left;
}
  .placeSuggestion:hover{
    background: rgb(250, 250, 250);
      transition: all 0.5s ease;
    -webkit-transform: scale(1.07);
    transform: scale(1.07);
    cursor: pointer;
  }
}
/*! rtl:end:ignore */
</style>
